export enum Status {
    PENDING = 1,
    APPROVED,
    SUPPRESSED
}